import SvgOptions from "../../../../../Components/Svg/SvgOptions";
import Svg from "../../../../../Components/Svg/Svg";
import css from "./AddQuestion.module.css";
import { EditIcon, EyeIcon, Trash, Trash2Icon } from "lucide-react";

const Question = ({ question, onAction }) => {
	return (
		<div className={css.QuestionContainer}>
			<div className={css.Question}>
				<Svg>{SvgOptions.Moving}</Svg>
				<p>{question.questionText}</p>
			</div>

			<div className={css.Actions}>
				<button
					className={css.ActionBtn}
					onClick={() => onAction("view", question)}
				>
					<EyeIcon size={16} />
				</button>

				<button
					className={css.ActionBtn}
					onClick={() => onAction("edit", question)}
				>
					<EditIcon size={16} />
				</button>

				{/* <button
					className={css.ActionBtn}
					onClick={() => onAction("delete", question)}
				>
					<Trash2Icon size={16} />
				</button> */}
			</div>
		</div>
	);
};

const QuestionsAside = ({ questions, onAction }) => {
	return (
		<div className={css.AsideContainer}>
			<h3>{questions?.length} Risk Assessment Questions</h3>
			<div className={css.title}>
				<h4>Question</h4>
				<h4>Actions</h4>
			</div>

			{questions.map((q) => (
				<Question key={q.id} question={q} onAction={onAction} />
			))}
		</div>
	);
};

export default QuestionsAside;
